var fieldReportPermissionsGrid = null,
    tbFieldReportPermissions = null,
    seatCheckGrid = null;

function initFieldReportsTab() {
	PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.FIELDREPORTS, 'FieldReports', {isOldModule: true}), $('#project-field-reports'), null, function () {
		renderFieldReports();
	});
}

function renderFieldReports() {
	PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALLADMIN, 'FieldReports', {
		isOldModule: true
	}), jQuery("#project-field-reports"), {}, function () {
		PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.FIELDREPORTS, 'FieldReports', {
			isOldModule: true
		}), jQuery("#field-report-list-pane"), {}, function () {
			FieldReportListInit();

			tbFieldReportPermissions = new dhtmlXToolbarObject("tbFieldReportPermissions");
			tbFieldReportPermissions.setSkin("dhx_web");
			tbFieldReportPermissions.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
			tbFieldReportPermissions.addButton('add', 0, 'Add', "new.gif", "new_dis.gif");
			tbFieldReportPermissions.addButton('edit', 1, 'Edit', "Edit.jpg", "EditD.jpg");
			tbFieldReportPermissions.disableItem('edit');
			tbFieldReportPermissions.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
			tbFieldReportPermissions.disableItem('delete');
			tbFieldReportPermissions.attachEvent("onClick", function (id) {
				switch (id) {
					case 'add':
						CreateFieldReportPermissionsForm('add');
						break;
					case 'edit':
						CreateFieldReportPermissionsForm('edit');
						break;
					case 'delete':
						showInfoDialogPWall('Delete Confirmation', 'Are you sure you want to delete this Permission?', 'ui-icon-alert', 'delete-field-report-permission');
						break;
				}
			});

			fieldReportSettingsGrid = new dhtmlXGridObject('fieldReportSettingsGrid');
			fieldReportSettingsGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
			fieldReportSettingsGrid.setSkin(pjqGridTheme);
			fieldReportSettingsGrid.enableAutoHeight(true);
			//fieldReportsGrid.enableContextMenu(projectStatusGridMenu);
			fieldReportSettingsGrid.init();
			fieldReportSettingsGrid.attachEvent("onRowSelect", function (id, ind) {
				tbFieldReportPermissions.enableItem('edit');
				tbFieldReportPermissions.enableItem('delete');
			});
			fieldReportSettingsGrid.attachEvent("onRowDblClicked", function (rId, cInd) {
				CreateFieldReportPermissionsForm('edit');
			});

			fieldReportSettingsGrid.attachEvent("onXLE", function (grid_obj, count) {
				jQuery('#field-report-settings-loading').hide();
				jQuery('#tbFieldReportPermissions').show();
			});

			fieldReportSettingsGrid.load("/DesktopModules/PJQProjectWallAdmin/GetFieldReportSettings.aspx?permissions=true&sessionid=" + pjqSessionId + '&x=' + (new Date).getTime(), 'xml');


			jQuery("#field-reports-accordion").accordion({
				heightStyle: "content"
			});
		});
	});
}

var dlgFieldReportPermissions = null, frpLastFormMode = null;

function CreateFieldReportPermissionsForm(mode) {
	frpLastFormMode = mode;
	switch (mode) {
		case 'add':
			frpId = 0;
			break;
		case 'edit':
			frpId = parseInt(fieldReportSettingsGrid.getSelectedRowId());
			break;
	}
	PanteraScript.PanteraScriptService.GetProjectFieldReportPermissionInfo(pjqSessionId, frpId, CreateFieldReportPermissionsFormC, onScriptError);
}

var fieldReportPermission = null;

function CreateFieldReportPermissionsFormC(response) {
	fieldReportPermission = jQuery.parseJSON(response);

	jQuery('#frp-report-type').val('');
	jQuery('#frp-report-type option').remove();

	jQuery('#frp-submitter-list, #frp-notify-submission-list').text('None');

	PanteraScript.PanteraScriptService.GetRFIContactInfo(pjqSessionId, fieldReportPermission.AssigneeList, project.ProjectId, 'submitter', GetFRPContactInfoC, onScriptError);
	PanteraScript.PanteraScriptService.GetRFIContactInfo(pjqSessionId, fieldReportPermission.NotifyAddList, project.ProjectId, 'notifyadd', GetFRPContactInfoC, onScriptError);

	var i = 0;
	var newopt = "<option value=''>Select...</option>";
	jQuery('#frp-report-type').append(newopt);
	for (i = 0; i < fieldReportPermission.ReportTypes.length; i++) {
		newopt = "<option value='" + fieldReportPermission.ReportTypes[i].FieldReportDefinitionId.toString() + "'>" + fieldReportPermission.ReportTypes[i].Name + "</option>";
		jQuery('#frp-report-type').append(newopt);
	}

	if (fieldReportPermission.FieldReportDefinitionId > 0)
		jQuery('#frp-report-type').val(fieldReportPermission.FieldReportDefinitionId.toString());
	else
		jQuery('#frp-report-type').val('');

	jQuery('#addFRPSubmitterButton, #addFRPNotifyAddButton').button({
		icons: {
			primary: 'ui-icon-plusthick'
		},
		text: false
	}).off().on('click', function () {
		switch (jQuery(this).attr('id')) {
			case 'addFRPSubmitterButton':
				initFieldReportPermissionsChooserDialog('submitter');
				break;
			case 'addFRPNotifyAddButton':
				initFieldReportPermissionsChooserDialog('notifyadd');
				break;
		}
	});


	jQuery('#frp-send-reminders-no').prop('checked', !fieldReportPermission.IsSendReminder);
	jQuery('#frp-send-reminders-yes').prop('checked', fieldReportPermission.IsSendReminder);

	jQuery('#frp-reminder-day-su').prop('checked', fieldReportPermission.ReminderDays.indexOf('Sun') != -1);
	jQuery('#frp-reminder-day-mo').prop('checked', fieldReportPermission.ReminderDays.indexOf('Mon') != -1);
	jQuery('#frp-reminder-day-tu').prop('checked', fieldReportPermission.ReminderDays.indexOf('Tue') != -1);
	jQuery('#frp-reminder-day-we').prop('checked', fieldReportPermission.ReminderDays.indexOf('Wed') != -1);
	jQuery('#frp-reminder-day-th').prop('checked', fieldReportPermission.ReminderDays.indexOf('Thu') != -1);
	jQuery('#frp-reminder-day-fr').prop('checked', fieldReportPermission.ReminderDays.indexOf('Fri') != -1);
	jQuery('#frp-reminder-day-sa').prop('checked', fieldReportPermission.ReminderDays.indexOf('Sat') != -1);

	jQuery('#frp-reminder-start').val(fieldReportPermission.ReminderStartDate);
	jQuery('#frp-reminder-end').val(fieldReportPermission.ReminderEndDate);
	jQuery('#frp-reminder-time').val(fieldReportPermission.ReminderTime);

	jQuery('#frp-reminder-start, #frp-reminder-end').datepicker({
		showOn: "button",
		numberOfMonths: 3,
		showButtonPanel: true,
		buttonImage: "/i/calendar.png",
		buttonImageOnly: true,
		onSelect: ValidateFRPDateHelper
	});


	jQuery("#frp-reminder-time").each(function () {
		if (!jQuery(this).hasClass('hasTimepicker')) {
			jQuery(this).timepicker({
				showOn: 'button',
				showPeriod: true,
				minutes: {
					interval: 15
				},
				button: jQuery(this).siblings('.ui-timepicker-trigger'),
				onSelect: ValidateFRPTimeHelper
			});
		}

		jQuery(this).off("click.remindertime").on("click.remindertime", function () {
			jQuery(this).siblings('.ui-timepicker-trigger').click();
		});
	});

	EnableFRPReminder(fieldReportPermission.IsSendReminder);

	if (fieldReportPermission.AssigneeList == 'PC') {
		jQuery('#frp-submitter-pc').prop('checked', true);
		EnableFRPSubmitter('frp-submitter-pc');
	}
	else {
		jQuery('#frp-submitter-specify').prop('checked', true);
		var assigneeListTemp = fieldReportPermission.AssigneeList;
		EnableFRPSubmitter('frp-submitter-specify');
		fieldReportPermission.AssigneeList = assigneeListTemp;
	}

	var dlgTitle = 'Add Permission';
	switch (frpLastFormMode) {
		case 'add':
			dlgTitle = 'Add Permission';
			break;
		case 'edit':
			dlgTitle = 'Edit Permission';
			break;
	}

	jQuery('#field-report-permissions-form button').button();

	jQuery('#field-report-permissions-header').text(dlgTitle);

	jQuery('#field-reports-accordion').hide();
	jQuery('#field-report-permissions-form').show();
}

function ValidateFRPDateHelper(name, sender) {
	var id = jQuery(sender).attr('id');

	ClearValidationError('#' + id);

	if (!ValidateDate(jQuery('#' + id).val()))
		SetValidationError('#' + id, 'Please enter a valid date.');
}

function ValidateFRPTimeHelper(name, sender) {

}

function EnableFRPReminder(enabled) {

	jQuery('#frp-reminder-start, #frp-reminder-end, #frp-reminder-day-su, #frp-reminder-day-mo, #frp-reminder-day-tu, #frp-reminder-day-we, #frp-reminder-day-th, #frp-reminder-day-fri, #frp-reminder-day-sa').prop('disabled', !enabled);

	jQuery("#frp-reminder-start, #frp-reminder-end").datepicker("option", "disabled", !enabled);
	jQuery("#frp-reminder-time").timepicker("option", "disabled", !enabled);
	jQuery('#frp-reminder-time').prop('disabled', !enabled)

}

var fieldReportChooserMode = '', isFieldReportChooserGridInit = null, fieldReportChooserGrid = null,
	fieldReportChooserGridTb = null;

function initFieldReportPermissionsChooserDialog(mode) {
	var dialogTitle = '';
	if (mode == 'submitter') {
		dialogTitle = 'Add Allowed Submitters';
	}
	else if (mode == 'notifyadd') {
		dialogTitle = 'Add Notifications (Report Submitted)';
	}
	else if (mode == 'nodifyedit') {
		dialogTitle = 'Add Notifications (Report Edited)';
	}

	fieldReportChooserMode = mode;

	jQuery('#fieldReportChooserDialog').dialog({
		title: dialogTitle,
		modal: true,
		resizable: false,
		dialogClass: 'fieldReportChooserDialog',
		width: 700,
		position: 'top',
		open: function (e, ui) {
			if (false /*isFieldReportChooserGridInit*/) {
				fieldReportChooserGrid.loadXML(getGridURLFieldReportChooser());
				fieldReportChooserGridTb.disableItem('add');
			}
			else {
				jQuery('#isShowITBFRP').prop('checked', false);
				if (fieldReportChooserGridTb && fieldReportChooserGridTb.setValue)
					fieldReportChooserGridTb.setValue('searchFor', '');
				jQuery('#isShowITBFRP').on('change', function () {
					fieldReportChooserGrid.loadXML(getGridURLFieldReportChooser());
				})
				isfieldReportChooserGridInit = true;
				fieldReportChooserGrid = new dhtmlXGridObject('fieldReportChooserGrid');
				fieldReportChooserGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
				fieldReportChooserGrid.setSkin(pjqGridTheme);
				fieldReportChooserGrid.enableAutoHeight(true);
				fieldReportChooserGrid.enablePaging(true, 10, 3, "fieldReportChooserGridPaging", true);
				fieldReportChooserGrid.setPagingSkin("toolbar", "dhx_web");
				fieldReportChooserGrid.setDragBehavior('complex');
				fieldReportChooserGrid.setDelimiter('|');
				fieldReportChooserGrid.loadXML(getGridURLFieldReportChooser());
				fieldReportChooserGrid.init();
				fieldReportChooserGrid.attachEvent("onXLE", function (grid_obj, count) {

					var existingList = [];
					if (fieldReportChooserMode == 'submitter') {
						existingList = fieldReportPermission.AssigneeList.split(',');
					}
					else if (fieldReportChooserMode == 'notifyadd') {
						existingList = fieldReportPermission.NotifyAddList.split(',');
					}

					for (var i = 0; i < existingList.length; i++) {
						if (fieldReportChooserGrid.getRowIndex(existingList[i]) != -1) {
							fieldReportChooserGrid.cells(existingList[i], 0).setValue(1);
						}

					}

					fieldReportChooserGrid.setSizes();
				});
				fieldReportChooserGrid.attachEvent("onCheck", function (id, ind, state) {
					var tempCheckedRows = fieldReportChooserGrid.getCheckedRows(0).split(',');
					var checkedRows = [];
					for (var i = 0; i < tempCheckedRows.length; i++) {
						if (tempCheckedRows[i] && !fieldReportChooserGrid.cells(tempCheckedRows[i], 0).cell._disabled)
							checkedRows.push(tempCheckedRows[i]);
					}
					if (checkedRows.length === 0)
						fieldReportChooserGridTb.disableItem('add');
					else
						fieldReportChooserGridTb.enableItem('add');
				});

				fieldReportChooserGridTb = new dhtmlXToolbarObject("fieldReportChooserGridToolbar");
				fieldReportChooserGridTb.setSkin("dhx_web");
				fieldReportChooserGridTb.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
				fieldReportChooserGridTb.addInput('searchFor', 0, '', 200);
				fieldReportChooserGridTb.addSeparator('search_sep', 1);
				fieldReportChooserGridTb.addButton("search", 2, "Search", "action_search.gif", "");
				fieldReportChooserGridTb.addSpacer("search");
				fieldReportChooserGridTb.addSeparator("add", 3);
				fieldReportChooserGridTb.addButton("add", 4, "Add Selected", "AddContact.png", "AddContactD.png");
				fieldReportChooserGridTb.disableItem('add');
				fieldReportChooserGridTb.attachEvent("onClick", function (id) {
					switch (id) {
						case 'search':
							fieldReportChooserGrid.loadXML(getGridURLFieldReportChooser());
							break;
						case 'add':
							var selectedIds = [];
							var i = 0;
							for (i = 0; i < fieldReportChooserGrid.getRowsNum(); i++) {
								if (fieldReportChooserGrid.cells2(i, 0).isChecked())
									selectedIds.push(fieldReportChooserGrid.getRowId(i));
							}

							if (fieldReportChooserMode == 'submitter') {
								fieldReportPermission.AssigneeList = selectedIds.join(',');
								PanteraScript.PanteraScriptService.GetRFIContactInfo(pjqSessionId, fieldReportPermission.AssigneeList, project.ProjectId, 'submitter', GetFRPContactInfoC, onScriptError);
							}
							else if (fieldReportChooserMode == 'notifyadd') {
								fieldReportPermission.NotifyAddList = selectedIds.join(',');
								PanteraScript.PanteraScriptService.GetRFIContactInfo(pjqSessionId, fieldReportPermission.NotifyAddList, project.ProjectId, 'notifyadd', GetFRPContactInfoC, onScriptError);
							}

							break;
					}
				});
				jQuery('#fieldReportChooserGridToolbar input.inp').keypress(function (event) {
					if (event.which == 13) {
						event.preventDefault();
						fieldReportChooserGrid.loadXML(getGridURLFieldReportChooser());
					}
				});
			}
		}
	});
}

function getGridURLFieldReportChooser() {
	var response = '/DesktopModules/PJQProjectWallAdmin/GetPCGrid.aspx?dialog=true';


	if (fieldReportChooserMode == 'notifyadd') {
		//response += 'chooser=users';
	}
	else {
		//response += 'chooser=contacts';

	}

	if (jQuery('#isShowITBFRP').prop('checked'))
		response += '&pct=itb'

	response += '&sessionId=' + pjqSessionId;

	if (fieldReportChooserGridTb != null) {
		var frpSearchFor = fieldReportChooserGridTb.getValue('searchFor').trim();
		if (frpSearchFor.length > 0)
			response += '&s=' + encodeURI(frpSearchFor);
	}

	return response;
}

function GetFRPContactInfoC(response) {
	var addedContacts = jQuery.parseJSON(response);
	populateFRPUserLists(addedContacts.ContactList, addedContacts.ContactAddType);

	if (fieldReportChooserMode != null) {
		fieldReportChooserMode = null;
		if (jQuery('#fieldReportChooserDialog').hasClass('ui-dialog-content'))
			jQuery('#fieldReportChooserDialog').dialog('close');
	}

	/*
	if (addedContacts.ContactAddType == 'distribution') {
		isRFIDistributionListInit = true;
	} else if (addedContacts.ContactAddType == 'assignee') {
		isRFIAssigneeListInit = true;
	}
	hideRFIModal();
	*/
}

function populateFRPUserLists(userList, type) {
	var domId = '';
	if (type == 'submitter') {
		domId = 'frp-submitter-list'
	}
	else if (type == 'notifyadd') {
		domId = 'frp-notify-submission-list';
	}
	jQuery('#' + domId).empty();

	if (userList.length == 0) {
		jQuery('#' + domId).html("None");
	}
	else {
		var replaceCommas = new RegExp('"', 'g');

		for (var i = 0; i < userList.length; i++) {
			var displayName = userList[i].Name + ' \n(' + userList[i].CompanyName + ')';
			displayName = displayName.replace(replaceCommas, '');

			var title = userList[i].CompanyName + '\n' + userList[i].Name + '\n' + userList[i].Email + '\n' + FormatPhoneHelper(userList[i].Phone);
			title = title.replace(replaceCommas, '');
			jQuery('#' + domId).append('<div title="' + title + '" class="frpUserObject" id="' + type + '_' + userList[i].Id + '"><div class="frpUserObjectName">' + displayName + '</div><div class="rfiUserObjectButtonContainer"><span onclick="deleteFieldReportContact(' + userList[i].Id + ',\'' + type + '\')" class="ui-icon ui-icon-closethick"></span></div></div>');
		}
	}
}

function deleteFieldReportContact(id, type) {

	var tempArr = [];
	if (type == 'submitter') {
		tempArr = fieldReportPermission.AssigneeList.split(',');
		RemoveIfPresent(tempArr, id.toString());
		fieldReportPermission.AssigneeList = tempArr.join(',');
		if (tempArr.length == 0)
			jQuery('#frp-submitter-list').text('None');
	}
	else if (type == 'notifyadd') {
		tempArr = fieldReportPermission.NotifyAddList.split(',');
		RemoveIfPresent(tempArr, id.toString());
		fieldReportPermission.NotifyAddList = tempArr.join(',');
		if (tempArr.length == 0)
			jQuery('#frp-notify-submission-list').text('None');
	}

	jQuery('#' + type + '_' + id).remove();
}


function frpSaveButton() {
	var hasErrors = false;
	ClearValidationError('#frp-report-type');
	if (jQuery('#frp-report-type').val() == '') {
		SetValidationError('#frp-report-type', 'Please select a Report Type.');
		hasErrors = true;
	}

	ClearValidationError('#frp-submitter-list');
	if (fieldReportPermission.AssigneeList.length == 0) {
		SetValidationError('#frp-submitter-list', 'Please select at least one submitter/option.');
		hasErrors = true;
	}

	ClearValidationError('#frp-reminder-start');
	ClearValidationError('#frp-reminder-end');
	ClearValidationError('#frp-reminder-time');
	ClearValidationError('#frp-reminder-day-su');
	if (jQuery('#frp-send-reminders-yes').prop('checked')) {

		var hasDateError = false;
		if (!ValidateDate(jQuery('#frp-reminder-start').val())) {
			SetValidationError('#frp-reminder-start', 'Please enter a valid date.');
			hasErrors = true;
			hasDateError = true;
		}

		if (!ValidateDate(jQuery('#frp-reminder-end').val())) {
			SetValidationError('#frp-reminder-end', 'Please enter a valid date.');
			hasErrors = true;
			hasDateError = true;
		}

		if (!hasDateError) {
			var dateStart = new Date(jQuery('#frp-reminder-start').val());
			var dateEnd = new Date(jQuery('#frp-reminder-end').val());

			if (dateEnd < dateStart) {
				SetValidationError('#frp-reminder-start', 'Start date is after End date.');
				hasErrors = true;
			}
		}

		if (!jQuery('#frp-reminder-day-su').prop('checked') &&
			!jQuery('#frp-reminder-day-mo').prop('checked') &&
			!jQuery('#frp-reminder-day-tu').prop('checked') &&
			!jQuery('#frp-reminder-day-we').prop('checked') &&
			!jQuery('#frp-reminder-day-th').prop('checked') &&
			!jQuery('#frp-reminder-day-fr').prop('checked') &&
			!jQuery('#frp-reminder-day-sa').prop('checked')) {

			SetValidationError('#frp-reminder-day-su', 'Please select at least one day.');
			hasErrors = true;

		}


	}

	if (!hasErrors) {
		if (settings.UserSeatLimit && settings.UserSeatLimit > 0) {

			var contactIdList = fieldReportPermission.AssigneeList;
			if (fieldReportPermission.NotifyAddList.length > 0) {
				if (contactIdList.length > 0)
					contactIdList += ',';

				contactIdList += fieldReportPermission.NotifyAddList;
			}

			InitializeSeatCheckGrid(contactIdList, SaveFieldReportPermission);
		}
		else
			SaveFieldReportPermission();
	}
}

function SaveFieldReportPermission() {
	var endpoint = 'AddProjectFieldReportPermission';
	if (frpLastFormMode == 'edit')
		endpoint = 'ModifyProjectFieldReportPermission';

	var reminderDays = [];
	if (jQuery('#frp-reminder-day-su').prop('checked'))
		reminderDays.push('Sun');
	if (jQuery('#frp-reminder-day-mo').prop('checked'))
		reminderDays.push('Mon');
	if (jQuery('#frp-reminder-day-tu').prop('checked'))
		reminderDays.push('Tue');
	if (jQuery('#frp-reminder-day-we').prop('checked'))
		reminderDays.push('Wed');
	if (jQuery('#frp-reminder-day-th').prop('checked'))
		reminderDays.push('Thu');
	if (jQuery('#frp-reminder-day-fr').prop('checked'))
		reminderDays.push('Fri');
	if (jQuery('#frp-reminder-day-sa').prop('checked'))
		reminderDays.push('Sat');

	new PJQ.ajax.Request({
		endpoint: "/fieldreport/" + endpoint,
		data: {
			fieldReportDefinitionId: parseInt(jQuery('#frp-report-type').val()),
			projectFieldReportPermissionId: parseInt(fieldReportSettingsGrid.getSelectedRowId()),
			assigneeList: fieldReportPermission.AssigneeList,
			isSendReminder: jQuery('#frp-send-reminders-yes').prop('checked'),
			reminderStartDate: jQuery('#frp-reminder-start').val(),
			reminderEndDate: jQuery('#frp-reminder-end').val(),
			reminderTime: jQuery('#frp-reminder-time').val(),
			reminderDays: reminderDays.join(','),
			notifyAddList: fieldReportPermission.NotifyAddList
		}
	}).post().done(function (data) {
		UpdateFieldReportPermissionC(data);
	});
}

function UpdateFieldReportPermissionC(response) {
	jQuery('#field-report-permissions-form').hide();
	jQuery('#field-reports-accordion').show();
	fieldReportSettingsGrid.clearAndLoad("/DesktopModules/PJQProjectWallAdmin/GetFieldReportSettings.aspx?permissions=true&sessionid=" + pjqSessionId + '&x=' + (new Date).getTime(), "xml");
}

function frpCancelButton() {
	jQuery('#field-report-permissions-form').hide();
	jQuery('#field-reports-accordion').show();
}

function EnableFRPSubmitter(senderId) {
	if (jQuery('#frp-submitter-pc').prop('checked')) {
		fieldReportPermission.AssigneeList = 'PC';
		jQuery('#frp-submitter-list').text('None');
		jQuery('#addFRPSubmitterButton').button("disable");
		jQuery('#frp-send-reminders-no,#frp-send-reminders-yes').prop('disabled', true);
		jQuery('#frp-send-reminders-no').prop('checked', true);
		ClearValidationError('#frp-submitter-list');
		EnableFRPReminder(false);
	}
	else if (jQuery('#frp-submitter-specify').prop('checked')) {
		fieldReportPermission.AssigneeList = '';
		jQuery('#addFRPSubmitterButton').button("enable");
		jQuery('#frp-send-reminders-no,#frp-send-reminders-yes').prop('disabled', false);
	}
}

function DeleteFieldReportPermission() {
	PanteraScript.PanteraScriptService.DeleteProjectFieldReportPermission(pjqSessionId, parseInt(fieldReportSettingsGrid.getSelectedRowId()), DeleteFieldReportPermissionC, onScriptError);
}

function DeleteFieldReportPermissionC() {
	fieldReportSettingsGrid.clearAndLoad("/DesktopModules/PJQProjectWallAdmin/GetFieldReportSettings.aspx?permissions=true&sessionid=" + pjqSessionId + '&x=' + (new Date).getTime(), "xml");
}

